import React from "react";

import HomeHero from "./HomeHero.jsx";

import HomeContent from "./HomeContent";
import Seo, {
  breadcrumbSchema,
  organizationSchema,
  privateLabelServiceSchema,
  webPageSchema,
  websiteSchema,
} from "../Seo/Seo";

function Home() {
  return (
    <main className="home-page mobile-type">
    <Seo
      title="Private Label Laundry Detergent Sheets Manufacturer | Klean Leaf"
      description="Launch private label laundry detergent sheets with Klean Leaf. Get custom formula, scent, packaging, wholesale production, samples, and logistics support."
      path="/"
      schema={[
        organizationSchema,
        websiteSchema,
        privateLabelServiceSchema,
        webPageSchema({
          name: "Private Label Laundry Detergent Sheets Manufacturer | Klean Leaf",
          description: "Launch private label laundry detergent sheets with Klean Leaf. Get custom formula, scent, packaging, wholesale production, samples, and logistics support.",
          path: "/",
        }),
        breadcrumbSchema([{ name: "Home", path: "/" }]),
      ]}
    />
    <HomeHero />
    <HomeContent />
    </main>
  );
}

export default Home;
